import { render, staticRenderFns } from "./BulletinsAddEdit.vue?vue&type=template&id=29ef635b"
import script from "./BulletinsAddEdit.vue?vue&type=script&lang=js"
export * from "./BulletinsAddEdit.vue?vue&type=script&lang=js"
import style0 from "./BulletinsAddEdit.vue?vue&type=style&index=0&id=29ef635b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports